module.exports = __webpack_public_path__ + "static/img/logo_whoiswho.6bf17d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand/logo_whoiswho.png
// module id = oFtH
// module chunks = 1